import React from 'react';

function Question({ dir, currentQuestion, number, level, onClick, root }) {
  const choices = [];
  currentQuestion.choices.forEach((val, index) => {
    let choiceNumber;
    if (currentQuestion.choicesnumber) {
      choiceNumber = currentQuestion.choicesnumber[index];
    } else {
      choiceNumber = Number(index + 1);
    }
    choices.push(
      <div className="questionChoiceBtnCol" key={index} index={index}>
        <button
          onTouchStart={() => {}}
          className="questionChoiceBtn"
          onClick={() => {
            if (currentQuestion.correct == index) {
              root.dispatchEvent(
                new CustomEvent('correct', {
                  detail: {
                    level: level + 1,
                    number: number + 1,
                  },
                })
              );
              onClick(4);
            } else {
              root.dispatchEvent(
                new CustomEvent('incorrect', {
                  detail: {
                    level: level + 1,
                    number: number + 1,
                  },
                })
              );
              onClick(3);
            }
          }}
        >
          <div className={currentQuestion.vertical ? 'questionChoiceBtnInner vertical' : 'questionChoiceBtnInner'}>
            <span className="number">
              <img src={dir + 'assets/img/number-choice-' + choiceNumber + '.png'} alt={choiceNumber} className="offBtn" />
              <img src={dir + 'assets/img/number-choice-' + choiceNumber + '-on.png'} alt={choiceNumber} className="onBtn" />
            </span>
            <span className="txt" dangerouslySetInnerHTML={{ __html: val }} />
          </div>
        </button>
      </div>
    );
  });
  return (
    <div className="questionContent">
      <div className="questionTitle">
        <div className="questionNumber questionPageTitle">
          <img src={dir + 'assets/img/number-title-' + Number(number + 1) + '.png'} alt={Number(number + 1)} />
        </div>
        <div className="questionTitleInner">
          <div dangerouslySetInnerHTML={{ __html: currentQuestion.title }} />
        </div>
      </div>
      <div className="questionMain">
        <div className="questionMainIllust">
          <img src={dir + 'assets/img/illust/' + Number(level + 1) + '/illust-' + Number(number + 1) + '.png'} alt="" className={'illust-' + Number(level + 1) + '-' + Number(number + 1)} />
        </div>
        <div className={'questionMainHint ' + 'number-' + Number(level + 1) + '-' + Number(number + 1)}>
          <button
            onTouchStart={() => {}}
            className="questionHintBtn"
            onClick={() => {
              onClick(2);
            }}
          >
            <img src={dir + 'assets/img/illust-hint-doctor.png'} alt="ヒント" />
          </button>
        </div>
      </div>
      <div className="questionChoiceBtns">{choices}</div>
    </div>
  );
}

export default Question;
